(function () {
  /**
   * @ngdoc component
   * @name abxHeader
   *
   * @param {String} headerText - Sets the header text
   * @param {String} headerIcon - Sets the header icon to a material icon
   * @param {String} headerIconColor - CSS color value of the header icon
   *
   * @description
   * A header component allowing user to switch organizations or enter a search query
   */
  angular
    .module("akitabox.mobile.components.header", [
      "akitabox.core.services.shadow",
    ])
    .controller("Header", HeaderController)
    .component("abxHeader", {
      bindings: {
        hideSearch: "<?hideSearch",
        showActions: "<?showActions",
        searchQuery: "=?searchQuery",
        headerText: "@headerText",
        headerIcon: "@headerIcon",
        headerIconColor: "@headerIconColor",
        actions: "<?abxActions",
        actionMenuOpen: "=?abxActionMenuOpen",
      },
      controller: HeaderController,
      controllerAs: "vm",
      templateUrl: "app/mobile/components/header/header.component.html",
    });

  /* @ngInject */
  function HeaderController() {
    var self = this;

    // Private Constants

    // Attributes
    self.searchOpen = self.searchQuery && self.searchQuery.length > 0;
    self.actionMenuOpen = false;

    // Functions
    self.searchToggle = searchToggle;
    self.clearSearch = clearSearch;
    self.toggleActionMenu = toggleActionMenu;

    function searchToggle() {
      self.searchOpen = !self.searchOpen;

      if (!self.searchOpen) {
        self.clearSearch();
      }
    }

    function toggleActionMenu() {
      self.actionMenuOpen = !self.actionMenuOpen;
    }

    function clearSearch() {
      self.searchQuery = "";
    }
  }
})();
